import React, { useState } from 'react';
import './index.css';
import 'react-tabs/style/react-tabs.css';

import FileUploaderWithProgress from './FileUploadWithProgress';
import CopyPasteSpecs from './CopyPasteSpecs';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import ListAltIcon from '@material-ui/icons/ListAlt';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import styled from 'styled-components';
import { useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const IntroPaper = styled(Paper)`
    margin-top: 8px;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fafafa;
`;

const BulletList = styled.ul`
    margin: 8px 0 0 18px;
`;

const TabsSection = styled(Paper)`
    margin-top: 16px;
`;

const TabsPanelSection = styled(Paper)`
    margin-top: 8px;
`;

const ToggleLink = styled.button`
    appearance: none;
    border: 0;
    background: transparent;
    padding: 0;
    margin-top: 6px;
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
    font: inherit;
    line-height: 1.4;
`;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

export default function AddRecommendations() {
    const [value, setValue] = useState(0);
    const [showMore, setShowMore] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const workspaces = useSelector((state) => state.workspaces);

    if (!workspaces.fetched) return <p>Fetching workspaces...</p>;

    const summary =
        'Recommendations are the target values you want live on each URL — Title, Meta Description, H1, or an expected redirect Destination URL.';

    return (
        <>
            <IntroPaper elevation={0}>
                <Box display="flex" alignItems="flex-start">
                    <InfoOutlinedIcon style={{ marginRight: 8, marginTop: 2 }} />
                    <Box>
                        <Typography variant="subtitle1">What are “recommendations” and why use them?</Typography>

                        {/* Always show the short summary. On mobile this is the only thing visible until “Read more”. */}
                        <Typography variant="body2" color="textSecondary" paragraph>
                            {summary}
                        </Typography>

                        {/* Details: visible on desktop, collapsible on mobile */}
                        {(!isMobile || showMore) && (
                            <>
                                <Typography variant="body2" color="textSecondary" paragraph>
                                    They give you one place to record <b>what good looks like</b> so you can coordinate
                                    changes over time and across people.
                                </Typography>

                                <Typography variant="body2" color="textSecondary" component="div">
                                    <BulletList>
                                        <li>
                                            Ideal when you’re making <b>lots of changes</b> (template refresh, content updates,
                                            migrations) or when updates happen <b>gradually / by multiple people</b> and you need a
                                            single source of truth.
                                        </li>
                                        <li>
                                            The tool checks your site at <b>regular intervals</b> (e.g. daily, every 2h/4h) and
                                            highlights what already matches your targets vs. what still needs attention.
                                        </li>
                                        <li>
                                            Use <b>Destination URL</b> to assert expected <b>redirects</b> — particularly
                                            handy during migrations.
                                        </li>
                                    </BulletList>
                                </Typography>
                            </>
                        )}

                        {isMobile && (
                            <ToggleLink
                                type="button"
                                onClick={() => setShowMore((v) => !v)}
                                aria-expanded={showMore}
                                aria-controls="intro-details"
                            >
                                {showMore ? 'Show less' : 'Read more'}
                            </ToggleLink>
                        )}
                    </Box>
                </Box>
            </IntroPaper>

            <TabsSection>
                <Tabs value={value} variant="fullWidth" onChange={(e, newValue) => setValue(newValue)}>
                    <Tab icon={<ListAltIcon />} label="Copy/Paste from Excel" />
                    <Tab icon={<CloudUploadIcon />} label="Excel File upload" />
                </Tabs>
            </TabsSection>

            <TabsPanelSection>
                <TabPanel value={value} index={0}>
                    <CopyPasteSpecs workspaces={workspaces} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <FileUploaderWithProgress />
                </TabPanel>
            </TabsPanelSection>
        </>
    );
}
